import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from "@mui/material";
import { MainContent } from "IF/interfaceType";
import AlertAreaStatus from "./AlertAreaStatus";
import { useEffect, useState } from "react";

const formatDuration = (sec?: number) => {
  if (!sec) return "0秒";

  const d = Math.floor(sec / 86400);
  const h = Math.floor((sec % 86400) / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;

  let result = "";
  if (d > 0) result += `${d}日`;
  if (h > 0) result += `${h}時間`;
  if (m > 0) result += `${m}分`;
  if (s > 0) result += `${s}秒`;

  return result;
};

export const AlertPanel = ({
  panel,
  minusHeight,
}: {
  panel: MainContent;
  minusHeight?: number;
}) => {
  const theme = useTheme();
  const [tableBodyHeight, setTableBodyHeight] = useState(600);
  const hi = minusHeight ? minusHeight : 0;

  useEffect(() => {
    const updateHeight = () => {
      const windowHeight = window.innerHeight;
      const calculatedHeight = windowHeight - (310 + hi);
      setTableBodyHeight(calculatedHeight);
    };

    // 初期表示時とリサイズ時に高さを計算
    updateHeight();
    window.addEventListener("resize", updateHeight);

    // クリーンアップ
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [hi]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        gap: 1,
      }}
    >
      <AlertAreaStatus panel={panel} />
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: tableBodyHeight,
          overflowY: "auto",
          backgroundColor: theme.palette.custom.row,
          // 余白が気になる場合は有効化
          // p: 0,
        }}
      >
        <Table sx={{ width: "100%", tableLayout: "fixed" }}>
          <TableBody
            sx={{
              // display: "block" は削除（点線が途中で切れる原因）
              width: "100%",
            }}
          >
            {panel.alertDataList.map((worker, index) => (
              <TableRow key={index} sx={{ width: "100%" }}>
                {/* ===== オリジナル表示 ===== */}
                {/*
          <TableCell
            sx={{
              flexGrow: 2,
              whiteSpace: "nowrap",
              fontSize: "15px",
              paddingLeft: 1,
              paddingRight: 1,
              borderBottom: "1px dashed grey",
            }}
          >
            {worker.tagId} : {worker.name}
          </TableCell>
          <TableCell
            sx={{
              flexGrow: 1,
              textAlign: "right",
              whiteSpace: "nowrap",
              paddingLeft: 1,
              paddingRight: 1,
              fontSize: "15px",
              borderBottom: "1px dashed grey",
            }}
          >
            {worker.alertTime}
          </TableCell>
          */}

                {/* ===== 新表示（タグ＋名前1行目、時間2行目） ===== */}
                <TableCell
                  colSpan={2}
                  sx={{
                    width: "100%",
                    whiteSpace: "normal",
                    fontSize: "15px",
                    paddingLeft: 1,
                    paddingRight: 1,
                    borderBottom: "1px dashed rgba(0,0,0,0.2)",
                  }}
                >
                  {/* 1行目 */}
                  <div>
                    {worker.tagId} : {worker.name}
                  </div>

                  {/* 2行目 */}
                  <div style={{ fontSize: "15px", color: "#333", textAlign: "right" }}>
                    {worker.alertTime} ～ {worker.recoverTime}（{formatDuration(worker.durationSec)}）
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>    </Box>
  );
};

export default AlertPanel;
